module.exports = __webpack_public_path__ + "static/ericsson-c65b66f2690bcf0fa1afeafbb09a1068.png";